<!--
 * @Description: 特材加工结算审批
 * @Author: wangwangwang
 * @Date: 2020-11-18 15:34:16
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-12-21 16:54:22
-->
<template>
  <div class="flows-content">
    <el-container>
      <el-main style="margin-bottom: 20px; padding: 0">
        <el-container direction="vertical">
          <FlowHeader
            :isReadOnly="readOnly"
            @saveSubmit="handleSubmit(1)"
            @sendSubmit="handleSubmit(2)"
            @handleBackEnd="handleSubmit(3)"
            @handleCC="handleSubmit(4)"
            @handleAssign="handleSubmit(5)"
            @handleBackUp="handleSubmit(6)"
            @handleAssist="handleSubmit(7)"
            @handleNode="handleSubmit(8)"
            @handleNodeImage="handleSubmit(9)"
            @handleCollection="handleSubmit(10)"
          />
          <el-main class="info">
            <div>
              <el-input v-model="title" class="flow-title" :disabled="$route.query.type * 1 !== 1" placeholder="请输入流程标题"></el-input>
            </div>
            <div class="info-top">
              <div class="left">
                <span>单据号码：{{ billCode }}</span>
                <span class="text">制单日期：{{ billDate }}</span>
              </div>
              <div class="right">
                <span>发起人：{{ applyPerson }}</span>
                <span class="text">状态：{{ taskTypeText[taskStatus * 1] }}</span>
              </div>
            </div>
            <div class="bill_top">
              <!-- <span><span class="text">客户名称：</span>{{billDetails1.unitName}}</span> -->
              <span><span class="text">公司：</span>{{ billDetails1.company }}</span>
              <!-- <span><span class="text">站点名称：</span>{{billDetails1.stationName}}</span> -->
              <span><span class="text">结算时间：</span>{{ billDetails1.startTime }}至{{ billDetails1.endTime }}</span>
              <span><span class="text">结算单编号：</span>{{ billDetails1.statementNo }}</span>
            </div>
            <div class="bill_title1">结算信息</div>
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="billDetails1.detalList" tooltip-effect="dark">
              <el-table-column label="生效时间" align="center" width="175">
                <template slot-scope="scope"> {{ scope.row.startTime }}至{{ scope.row.endTime }} </template>
              </el-table-column>
              <el-table-column label="生产类型" align="center" prop="planType">
                <template slot-scope="scope">
                  <span v-if="scope.row.planType == 0">正常生产</span>
                  <span v-else>调料生产</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="基础单价(元/吨)" align="center" prop="price"></el-table-column> -->
              <el-table-column label="加工量" align="center" prop="processNum"></el-table-column>
              <el-table-column label="结算量" align="center" prop="statementNum"></el-table-column>
              <el-table-column label="系统比例" align="center" prop="scale"></el-table-column>
              <el-table-column label="是否收费" align="center" prop="charge"></el-table-column>
              <el-table-column label="结算单价（元/吨）" align="center" prop="statementUnitPrice"></el-table-column>
              <el-table-column label="结算金额（元）" align="center" prop="statementMoney"></el-table-column>
            </el-table>
            <div class="bill_title1">调整金额</div>
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="billDetails1.deductionList" tooltip-effect="dark">
              <el-table-column label="公司" align="center" prop="cooperativeUnit"> </el-table-column>
              <el-table-column label="调整类型" align="center">
                <template slot-scope="scope">
                  <div v-for="(item, index) in deductionTypes" :key="index">
                    <span v-if="item.id == scope.row.deductionTypeId">{{ item.itemName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="调增调减" align="center" prop="addOrReduce">
                <template slot-scope="scope">
                  <span v-if="scope.row.influenceInvoice == 1">调增</span>
                  <span v-else>调减</span>
                </template>
              </el-table-column>
              <el-table-column label="调整金额" align="center" prop="deduction"> </el-table-column>
              <el-table-column label="是否影响开票" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.influenceInvoice == 1">是</span>
                  <span v-else>否</span>
                </template>
              </el-table-column>
              <el-table-column label="备注" align="center" prop="remark"></el-table-column>
            </el-table>
            <div class="bill_title">结算合计</div>
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="totalList1" tooltip-effect="dark">
              <el-table-column label="公司" align="center" prop="company"></el-table-column>
              <el-table-column label="结算量(吨)" align="center" prop="statementNum"></el-table-column>
              <el-table-column label="待结算金额 (元)" align="center" prop="settlementAmount"></el-table-column>
              <el-table-column label="调整金额 (元)" align="center" prop="deduction"></el-table-column>
              <el-table-column label="结算金额 (元)" align="center" prop="realPay"></el-table-column>
              <el-table-column label="开票金额 (元)" align="center" prop="faceAdjustment"></el-table-column>
            </el-table>
            <!-- <div class="combined">小计：收货量【{{combined(totalList1,'statementNum')}}】，结算金额【{{combined(totalList1,'statementMoney')}}】</div> -->
            <div class="flows-details">
              <FlowContent
                ref="flowcontent"
                :title="title"
                :showSendVisible="showSendVisible"
                @handleCancel="handleCancel"
                @sendCode="sendCode"
                @handleFinish="handleFinish"
                @handleBusiness="handleBusiness"
                @resetFlowState="resetFlowState"
              />
            </div>
          </el-main>
        </el-container>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import FlowContent from "@/components/WorkFlow/flowContent";
import FlowHeader from "@/components/WorkFlow/flowHeader";
import { getDicType } from "@/api/common.js";
import { getUserInfo } from "@/utils/auth.js";
import { get_statement_detail, update_status } from "@/api/wise/Wise_rentunit/Wise_rentunit5.js";
export default {
  components: {
    FlowContent,
    FlowHeader,
  },
  data() {
    return {
      type: 0,
      title: "特材加工结算审批",
      billCode: "",
      billDate: "",
      applyPerson: "",
      taskTypeText: ["发起", "已保存", "审批中", "已完成", "撤销", "不通过"],
      taskStatus: 0,
      readOnly: false,
      showSendVisible: false,
      billDetails1: {
        list: [],
      },
      totalList1: [],
      deductionTypes: [],
    };
  },
  methods: {
    //不同意回调
    resetFlowState() {
      this.handleBusiness();
    },
    combined(arr, item) {
      let num = 0;
      arr.forEach(res => {
        num = Number(res[item]) + num;
      });
      return num.toFixed(2);
    },
    handleBusiness() {
      const { query } = this.$route;
      const params = {
        process_success: {
          url: "/icps/system/sign/settlement/processingFee/updateAuditStatus",
          data: {
            statementNo: JSON.parse(query.dataContent).id,
            auditStatus: 3,
            statusType: 1,
          },
          httpMethod: "post",
        },
        process_failure: {
          url: "/icps/system/sign/settlement/processingFee/updateAuditStatus",
          data: {
            statementNo: JSON.parse(query.dataContent).id,
            auditStatus: 4,
            statusType: 1,
          },
          httpMethod: "post",
        },
      };
      this.showSendVisible = false;
      this.$refs.flowcontent.handleToFlow(params);
    },
    /**
     * @Description:
     * @Param: 1为保存，2为最后提交
     * @Author: wangwangwang
     * @param {*} type
     */
    handleFinish(type) {
      const { query } = this.$route;
      if (type == 1) {
        update_status({
          statementNo: query.id,
          auditStatus: 2,
          statusType: 1,
        }).then(() => {});
        return;
      }
    },
    handleSubmit(type) {
      const { query } = this.$route;
      if (query.type * 1 === 2 && type === 2 && query.taskType * 1 !== 2) {
        // 发起流程
        this.showSendVisible = true;
        return;
      }
      const data = {
        dataSource: "sign_Wise_rentunit5",
        dataContent: JSON.stringify({ id: query.id }), // 业务数据
      };
      this.$refs.flowcontent.saveFlows(type, data);
    },
    handleFlowChat() {
      this.$refs.flowcontent.showFlowNode();
    },
    handleCancel() {
      this.showSendVisible = false;
    },
    /**
     * @Description: 回显业务数据
     * @Param:
     * @Author: wangwangwang
     */
    initFlowsData(id) {
      get_statement_detail({ statementNo: id, mark: 1 }).then(res => {
        this.billDetails1 = res.data;
        let statementNumTotal = res.data.detalList.reduce((pre, cur) => {
          pre = pre*1 + cur.statementNum*1;
          return pre;
        }, 0);
        this.billDetails1.detalList.forEach(ress => {
          //结算量
          if ((ress.statementNum / statementNumTotal) * 1 < ress.scale) {
            ress.charge = "否";
          } else {
            ress.charge = "是";
          }
        });
        let deduction = res.data.deductionList.reduce((pre, cur) => {
          pre = pre + cur.deduction;
          return pre;
        }, 0);
        res.data.total.deduction = deduction;
        this.totalList1 = [];
        this.totalList1.push(res.data.total);
      });
      const { query } = this.$route;
      if (query.type * 1 !== 1) {
        this.title = query.taskName;
      }
      this.billCode = query.receiptNumber;
      this.billDate = query.createTime;
    },
    sendCode(code) {
      this.billCode = code;
    },
  },
  async created() {
    const { query } = this.$route;
    this.titlestatus = Number(query.type);
    const { data } = await getDicType({ code: "deductionType" });
    this.deductionTypes = data.items;
  },
  mounted() {
    const { query } = this.$route;
    if (query.type * 1 === 1) {
      // 发起流程
      this.initFlowsData(query.id);
      this.$refs.flowcontent.initBaseData("sign_Wise_rentunit1");
      this.billDate = new Date().Format("yyyy-MM-dd hh:mm:ss");
      this.applyPerson = getUserInfo().userRealName;
      return;
    }
    this.initFlowsData(JSON.parse(query.dataContent).id);
    this.applyPerson = query.createUserName;
    this.taskStatus = query.taskStatus;
    if (query.isReadOnly * 1 === 1) {
      this.readOnly = true;
    }
  },
};
</script>
<style lang="scss" scoped>
.bill_top {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  line-height: 40px;
  .text {
    font-weight: 600;
    color: #000;
  }
}
.bill_title {
  font-size: 18px;
  font-weight: 600;
  padding: 15px 0;
}
.bill_title1 {
  font-size: 18px;
  font-weight: 600;
  padding: 20px 0;
}
.bill_subtitle {
  padding: 20px 0;
  > span {
    padding-right: 20px;
  }
  .text {
    color: #000;
  }
}
.combined {
  border: 1px solid #ebeef5;
  text-align: center;
  line-height: 40px;
}
.flows-details {
  margin-top: 20px;
}
.info {
  padding: 0 20px;
  background: #fff;
  .info-top {
    font-size: $font_size;
    color: #000000;
    @include discen_al;
    justify-content: space-between;
    height: 50px;
    border-bottom: 1px #e1e5ed solid;
    .left {
      @include discen_al;
    }
    .text {
      margin-left: 60px;
    }
  }
}
.nav_title {
  @include discen_al;
  align-items: flex-end;
  > div {
    width: 4px;
    height: 24px;
    background: $bg_color;
    margin-right: 10px;
  }
  i {
    margin-left: 5px;
  }
  color: $bg_color;
  font-size: 20px;
  font-weight: bold;
}
.dialoginfo {
  padding: 0;
}
.active {
  border-top: 1px #e1e5ed solid;
  border-right: 1px #e1e5ed solid;
  border-left: 1px #e1e5ed solid;
  background: #fff;
}
.dialoginfo-info {
  border-right: 1px #e1e5ed solid;
  border-left: 1px #e1e5ed solid;
  border-bottom: 1px #e1e5ed solid;
}
/*弹窗*/
.dialoginfo-title {
  > div {
    cursor: pointer;
  }
  height: 48px;
  display: flex;
  background: linear-gradient(180deg, rgba(250, 252, 255, 1) 0%, rgba(245, 247, 250, 1) 100%);
  .none {
    font-weight: bold;
    height: 48px;
    @include discen;
    width: calc(calc(100% - 1px) / 2);
    border-bottom: 1px solid #e1e5ed;
    > div {
      line-height: 48px;
      border-bottom: 1px rgba(0, 0, 0, 0) solid;
    }
  }
  .center {
    width: 1px;
    height: 48px;
    background: #e1e5ed;
  }
  .active {
    font-weight: bold;
    height: 48px;
    @include discen;
    width: calc(calc(100% - 1px) / 2);
    border-bottom: 1px solid rgba(0, 0, 0, 0);
    > div {
      color: $bg_color;
      line-height: 48px;
      border-bottom: 1px $bg_color solid;
    }
  }
}
.dialoginfo-info {
  padding: 10px 20px;
  overflow: auto;
  height: calc(85vh - 282px);
  .el-select,
  .el-input,
  .el-date-picker {
    width: 100%;
  }
}
.form-title {
  font-size: 18px;
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
}
</style>